import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { useParams, useNavigate } from "react-router-dom";

const DriverView = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [driver, setDriver] = useState(null);
    const [stats, setStats] = useState(null);

    const loadDriver = async () => {
        dispatch(loadingTrue());

        const res = await Handler({
            method: "get",
            url: `/driver/view.php?id=${id}`
        });

        if (res.success) {
            setDriver(res.data.driver_info);
            setStats(res.data.statistics);
        }

        dispatch(loadingFalse());
    };

    useEffect(() => { loadDriver() }, []);

    return (
        <div className="page-card">

            <div className="page-header">
                <h4>Driver Details</h4>
                <button className="btn add-btn" onClick={() => navigate("/drivers")}>Back</button>
            </div>

            {/* DRIVER INFO */}
            <div className="info-grid mb-4">

                <div className="info-item">
                    <i className='bx bx-user'></i>
                    <div>
                        <span>Name</span>
                        <strong className="text-capitalize">{driver?.name}</strong>
                    </div>
                </div>

                <div className="info-item">
                    <i className='bx bx-phone'></i>
                    <div>
                        <span>Phone</span>
                        <strong>{driver?.phone}</strong>
                    </div>
                </div>

                <div className="info-item">
                    <i className='bx bx-id-card'></i>
                    <div>
                        <span>License</span>
                        <strong>{driver?.license_number}</strong>
                    </div>
                </div>

                <div className="info-item">
                    <i className='bx bx-check-circle'></i>
                    <div>
                        <span>Status</span>
                        <strong className={`status-badge ${driver?.status}`}>
                            {driver?.status}
                        </strong>
                    </div>
                </div>

            </div>

            {/* ⭐ KPI GRADIENT CARDS */}
            {/* ⭐ ALL STATISTICS — GRADIENT KPI CARDS */}
            <div className="kpi-grid">

                <div className="kpi-card gradient-blue">
                    <span>Total Dispatch</span>
                    <strong>{stats?.total_dispatch_assigned}</strong>
                </div>

                <div className="kpi-card gradient-purple">
                    <span>Total Trips</span>
                    <strong>{stats?.total_trip_logs}</strong>
                </div>

                <div className="kpi-card gradient-green">
                    <span>Total Hours</span>
                    <strong>{stats?.total_hours}</strong>
                </div>

                <div className="kpi-card gradient-orange">
                    <span>Normal Hours</span>
                    <strong>{stats?.normal_hours}</strong>
                </div>

                <div className="kpi-card gradient-pink">
                    <span>OT Hours</span>
                    <strong>{stats?.ot_hours}</strong>
                </div>

                <div className="kpi-card gradient-cyan">
                    <span>Peak Hours</span>
                    <strong>{stats?.peak_hours}</strong>
                </div>

                <div className="kpi-card gradient-red">
                    <span>Weekend</span>
                    <strong>{stats?.weekend_hours}</strong>
                </div>

                <div className="kpi-card gradient-dark">
                    <span>Holiday</span>
                    <strong>{stats?.holiday_hours}</strong>
                </div>

            </div>


        </div>
    );
};

export default DriverView;
